import React, { useState } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'
import { SearchUser } from './SearchUser/SearchUser'
import useStyles from './useStyles'
import { Navigate, Route, Routes } from 'react-router-dom'
import { SuscribersOfUser } from './Suscribers/SuscribersOfUser.jsx'
import OrganizationsOfUser from './Organizations/Organizations'
import {
  SnackBarError,
  SnackBarSuccess
} from '../../components/SnackBars/SnackBars'
import InfoIcon from '@mui/icons-material/Info'

export default function Users () {
  return (
    <Routes>
      <Route path="/" element={<User />} />
      <Route path="/:id" element={<User />} />
      <Route path=":id/subscribers" element={<SuscribersOfUser />} />
      <Route path=":id/organizations" element={<OrganizationsOfUser />} />
      <Route path="*" element={<Navigate replace to="/home" />} />
    </Routes>
  )
}
function User () {
  const classes = useStyles()

  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    setLoading(false)
  }

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>Usuarios</Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá visualizar la información de un usuario de
          Errepar+.
        </Typography>
      </div>

      <SearchUser setLoading={setLoading} />
      <SnackBarSuccess />
      <SnackBarError />
    </div>
  )
}
